import { ScrollReveal } from '@/components/ui/scroll-reveal'
import { Check } from 'lucide-react'

export const TargetAudienceSection = () => {
  return (
    <section id="target" className="py-24 bg-white">
      <div className="container px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <ScrollReveal>
            <div className="relative rounded-2xl overflow-hidden aspect-video md:aspect-square bg-slate-100">
              <img
                src="https://img.usecurling.com/p/800/800?q=modern%20office%20team&color=blue"
                alt="Equipa a trabalhar"
                className="object-cover w-full h-full hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-indigo-900/10 mix-blend-multiply" />
            </div>
          </ScrollReveal>

          <ScrollReveal delay={200}>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
              Para quem é?
            </h2>
            <p className="text-lg text-slate-600 mb-8">
              A nossa solução é ideal para negócios que querem crescer sem
              aumentar exponencialmente a equipa e os custos fixos.
            </p>

            <div className="space-y-4">
              {[
                'Usam Excel como ferramenta principal de gestão',
                'Têm tarefas repetitivas e manuais',
                'Dependem demasiado de pessoas-chave',
                'Lidam com grandes volumes de informação',
                'Querem escalar a operação com eficiência',
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 p-4 rounded-lg bg-slate-50 border border-slate-100 hover:border-primary/20 transition-colors"
                >
                  <div className="mt-1 bg-green-100 text-green-600 rounded-full p-1">
                    <Check size={14} />
                  </div>
                  <span className="font-medium text-slate-700">{item}</span>
                </div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  )
}
